import { render } from "./CruiseDetail.vue?vue&type=template&id=165bc75e&scoped=true"
import script from "./CruiseDetail.vue?vue&type=script&lang=js"
export * from "./CruiseDetail.vue?vue&type=script&lang=js"

import "./CruiseDetail.vue?vue&type=style&index=0&id=165bc75e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165bc75e"]])

export default __exports__